module.exports = __webpack_public_path__ + "img/kayizzi.41fc01e5.jpeg";